<div class="authBox-bd js-element--registerAndSignInContainer"></div>
<div class="authBox-ft">
    <div class="hList">
        <p class="lbl">{{#unless showRegister}}Don’t{{else}}Already{{/unless}} have an account?</p>
        <a href="" class="link link_carrot js-element--formToggle">{{#unless showRegister}}Register{{else}}Sign In{{/unless}}</a>
    </div>
</div>
